var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospital = function SvgHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.417 15c0-.69.56-1.25 1.25-1.25h2.083v-2.084a1.25 1.25 0 1 1 2.5 0v2.084h2.083a1.25 1.25 0 0 1 0 2.5H21.25v2.083a1.25 1.25 0 0 1-2.5 0V16.25h-2.083c-.69 0-1.25-.56-1.25-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35 36.25a1.25 1.25 0 1 0 0-2.5h-2.083V8.333a4.583 4.583 0 0 0-4.584-4.583H11.667a4.583 4.583 0 0 0-4.584 4.583V33.75H5a1.25 1.25 0 1 0 0 2.5zm-23.333-30a2.083 2.083 0 0 0-2.084 2.083V33.75h4.167v-5.417a4.584 4.584 0 0 1 4.583-4.583h3.334a4.584 4.584 0 0 1 4.583 4.583v5.417h4.167V8.333a2.083 2.083 0 0 0-2.084-2.083zm12.083 27.5v-5.417a2.083 2.083 0 0 0-2.083-2.083h-3.334a2.083 2.083 0 0 0-2.083 2.083v5.417z",
    clipRule: "evenodd"
  })));
};
export default SvgHospital;